import { atom } from 'recoil';

export const ipamAdminSectionState = atom({
    key: 'ipamAdminSection',
    default: '',
});

export const ipamAdminSectionOptionsState = atom({
    key: 'ipamAdminSectionOptions',
    default: [],
});

export const ipamAdminViewModeState = atom({
    key: 'ipamAdminViewMode',
    default: 'table',
});

export const IPAM_FILTER_DEFAULT = {
    provider: '',
    region: '',
    regionName: '',
    status: '',
    continent: '',
    type: '',
};

export const ipamAdminPendingFiltersState = atom({
    key: 'ipamAdminPendingFilters',
    default: { ...IPAM_FILTER_DEFAULT },
});

export const ipamAdminAppliedFiltersState = atom({
    key: 'ipamAdminAppliedFilters',
    default: { ...IPAM_FILTER_DEFAULT },
});

export const ipamAdminTypeOptionsState = atom({
    key: 'ipamAdminTypeOptions',
    default: [],
});

export const ipamAdminProviderOptionsState = atom({
    key: 'ipamAdminProviderOptions',
    default: [],
});

export const ipamAdminContinentOptionsState = atom({
    key: 'ipamAdminContinentOptions',
    default: [],
});

export const ipamAdminSearchTextState = atom({
    key: 'ipamAdminSearchText',
    default: '',
});

export const ipamAdminAddLabelState = atom({
    key: 'ipamAdminAddLabel',
    default: '',
});

export const ipamAdminAddTriggerState = atom({
    key: 'ipamAdminAddTrigger',
    default: 0,
});

export const ALLOCATION_FORM_DEFAULT = {
    creationType: 'params',
    provider: '',
    regionId: '',
    cidrType: '',
    allRegions: [],
    ipBlock: '',
    vnetName: '',
    resourceId: '',
    status: '',
    subnetPrefix: '',
    allowSplit: false,
    cidr: '',
    azCount: '',
    subnetTypes: [],
    subnetTypeOptions: [],
};

export const ipamAllocationFormState = atom({
    key: 'ipamAllocationForm',
    default: { ...ALLOCATION_FORM_DEFAULT },
});

export const SUPERNET_FORM_DEFAULT = {
    provider: '',
    region: '',
    cidr: '',
    type: '',
    continent: '',
    allRegions: [],
};

export const ipamSupernetFormState = atom({
    key: 'ipamSupernetForm',
    default: { ...SUPERNET_FORM_DEFAULT },
});

export const HUB_FORM_DEFAULT = {
    cloudProvider: '',
    region: '',
    hubName: '',
    hubResourceId: '',
    hubType: '',
    allRegions: [],
};

export const ipamHubFormState = atom({
    key: 'ipamHubForm',
    default: { ...HUB_FORM_DEFAULT },
});

export const REGION_FORM_DEFAULT = {
    cloudProvider: '',
    cloudRegion: '',
};

export const ipamRegionFormState = atom({
    key: 'ipamRegionForm',
    default: { ...REGION_FORM_DEFAULT },
});

export const SUPER_SUPERNET_FORM_DEFAULT = {
    continent: '',
    cidr: '',
};

export const ipamSuperSupernetFormState = atom({
    key: 'ipamSuperSupernetForm',
    default: { ...SUPER_SUPERNET_FORM_DEFAULT },
});
